import { render, staticRenderFns } from "./activeManage.vue?vue&type=template&id=fc5273da&scoped=true&"
import script from "./activeManage.vue?vue&type=script&lang=js&"
export * from "./activeManage.vue?vue&type=script&lang=js&"
import style0 from "./activeManage.vue?vue&type=style&index=0&id=fc5273da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5273da",
  null
  
)

export default component.exports